var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lookPower"},[(_vm.lookPower == 2)?_c('register'):_vm._e(),(_vm.lookPower == 3)?_c('live-password'):_vm._e(),(_vm.lookPower == 8)?_c('invite-code'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }